import { render } from "./elearningFolderManager.vue?vue&type=template&id=ad1c4466&scoped=true"
import script from "./elearningFolderManager.vue?vue&type=script&lang=js"
export * from "./elearningFolderManager.vue?vue&type=script&lang=js"

import "./elearningFolderManager.vue?vue&type=style&index=0&id=ad1c4466&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad1c4466"],['__file',"resources/js/vueComponents/admin/elearningFolderManager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad1c4466"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad1c4466', __exports__)) {
    api.reload('ad1c4466', __exports__)
  }
  
  module.hot.accept("./elearningFolderManager.vue?vue&type=template&id=ad1c4466&scoped=true", () => {
    api.rerender('ad1c4466', render)
  })

}


export default __exports__